import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

export type EventsAwardsNewsListingStoriesProps = {
  articleProps: ComponentProps<typeof Card>;
};

/**
 * Component to render news listing page for event and awards
 */
const EventsAwardsNewsListingStories = ({
  articleProps,
}: EventsAwardsNewsListingStoriesProps): React.ReactElement => {
  const variant: CardVariations = {
    kicker: {
      color: cn("text-gray-515"),
      extraClass: "font-public-sans",
    },
    image: {
      width: "w-2/5 lg:w-1/6 h-fit",
      position: "left",
      extraClass: "lg:order-2",
      filters: { w: 100, h: 100, dpr: 1, f: "webp" },
      aspectRatio: "aspect-3x2",
      imageClassName: cn("object-cover"),
    },
    content: {
      width: "w-3/5 lg:w-5/6",
      extraClass: cn("pl-4 lg:order-1 lg:pl-0 lg:pr-4"),
      blurb: {
        extraClass: cn("text-gray-750 font-open-sans"),
      },
      updatedTimeExtraClass: "text-7xs font-public-sans",
      updatedTimeWrapperClass: "lg:mt-auto",
    },
    title: {
      size: "text-base",
      color: "text-gray-850",
      extraClass: "font-public-sans my-1",
    },
  };

  return (
    <div
      data-testdata-testid="events-awards-news-listing-stories-component"
      className={cn("story border-b border-gray-175 py-4")}
    >
      <Card {...articleProps} variations={variant} className="items-stretch" />
    </div>
  );
};

export default EventsAwardsNewsListingStories;
